import { gql } from '@apollo/client';

const typeDefs = gql`
  type Query {
    isMobile: Boolean!
    user: Object
    isShell: Boolean!
  }
`;

export default typeDefs;
